module.exports = __webpack_public_path__ + "static/media/Aviso_compradores.a3fb5649.pdf";